import { customTextBlock, heading,
  paragraph,
  button } from "../../../text/nodes"
import { getFont } from "app/regions/blocks/shared/fonts"
import { ArticleCards as ArticleCardsEditor } from "./article-cards"
import { ArticleCardsSettings } from "./article-cards-settings"
import ArticleCardsPreview from "./article-cards-preview.png"

export const ArticleCards = {
  name: "ArticleCards",
  label: "two columns",
  EditorComponent: ArticleCardsEditor,
  SettingsComponent: ArticleCardsSettings,
  image: ArticleCardsPreview,
  defaultProperties: {
    backgroundColor: "#FFFFFF",
    horizontalPadding: 18,
    verticalPadding: 18,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: "#f0f0f0",
    borderTopWidth: 1,
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderBottomWidth: 1,
    headingColor: "#2C2C2C",
    textColor: "#4D4D4D",
    headingFontFamily: getFont("System Font"),
    headingFontWeight: 500,
    textFontFamily: getFont("System Font"),
    textFontWeight: 400,
    gap: 20
  },
  defaultChildren: [
    customTextBlock([
      heading("three", "Article title"),
      paragraph("Lorem ipsum dolor sit amet, consectetur adipiscing elit."),
      button("Read article", {
        alignment: "left",
        backgroundColor: "#2C2C2C"
      })
    ]),
    customTextBlock([
      heading("three", "Article title"),
      paragraph("Lorem ipsum dolor sit amet, consectetur adipiscing elit."),
      button("Read article", {
        alignment: "left",
        backgroundColor: "#2C2C2C"
      })
    ])
  ]
}
